import { Component, ElementRef, Input, OnInit, OnChanges, Output, EventEmitter } from '@angular/core';
import { CommonUtil } from '../../../../core/Utils/common-util';
import { RootScopeService } from '../../../../core/shared-service/root-scope.service';
import { RootScopeDeclare } from '../../../../core/rootscope-declare';
import { InvitedFacility, AcceptRejectRequestPayload } from 'src/app/post-login/services/multi-facility.model';
import { MultiFacilityService } from 'src/app/post-login/services/multi-facility.service';
import { HaloToastService, EToastType } from 'src/app/core/halo-toast/halo-toast.service';
import { elementAt } from 'rxjs/operators';
import { HaloLoaderService } from 'src/app/core/halo-loader/halo-loader.service';
import { AmplitudeAnalyticsService } from 'src/app/core/services/amplitude-analytics.service';

@Component({
  selector: 'app-manage-request',
  templateUrl: './manage-request.component.html',
  styleUrls: ['./manage-request.component.scss'],
})
export class ManageRequestComponent implements OnInit, OnChanges {
  rootScopeData: RootScopeDeclare;
  @Input() manageRequest: InvitedFacility[];
  @Output() callOnClick: EventEmitter<number> = new EventEmitter();

  showhide: { showMore: boolean };
  constructor(
    private rootScopeService: RootScopeService,
    private elRef: ElementRef,
    private commonUtil: CommonUtil,
    private multiFacService: MultiFacilityService,
    private _toast: HaloToastService,
    private _loader: HaloLoaderService,
    private _amplitudeAnalytics: AmplitudeAnalyticsService,
  ) {}

  ngOnInit(): void {
    this.getRootScopeData();
    this.showhide = { showMore: false };
  }
  ngOnChanges() {
    this.manageRequest.forEach((element) => Object.assign(element, this.showhide));
  }
  getRootScopeData(): void {
    this.rootScopeService.getRootScope().subscribe((rootScopeData) => {
      this.rootScopeData = rootScopeData;
    });
  }
  getMessage(message: string, request: InvitedFacility) {
    let info = '';
    if (message == 'message1') {
      info = this.commonUtil.replaceValueAsHTMLOnTranslatedText('MANAGE.REQUEST.MESSAGE.1', [
        this.getFullNameEmail(request.senderFirstName, request.senderLastName, request.senderEmail),
        request.requestedFacilityName,
      ]);
    } else if (message == 'message2') {
      info = this.commonUtil.replaceValueAsHTMLOnTranslatedText('MANAGE.REQUEST.MESSAGE.2', [
        this.getTitleCase(request.senderFirstName),
        request.requestedFacilityName,
        this.getTitleCase(request.senderFirstName),
      ]);
    } else if (message == 'message3') {
      info = this.commonUtil.replaceValueAsHTMLOnTranslatedText('MANAGE.REQUEST.MESSAGE.3', [
        this.getTitleCase(request.senderFirstName),
      ]);
    }
    return info;
  }
  getTitleCase(name: string) {
    return name.charAt(0).toUpperCase() + name.slice(1);
  }
  getFullNameEmail(firstName: string, lastname: string, email: string) {
    return `${this.getTitleCase(firstName)}  ${this.getTitleCase(lastname)} ( ${email} )`;
  }
  toggle(request: InvitedFacility) {
    request.showMore = !request.showMore;
  }
  showHide(request: InvitedFacility) {
    var index = this.manageRequest.indexOf(request);
    this.manageRequest[index].showMore = true;
  }

  onAcceptOrDeny(request: InvitedFacility, status: string) {
    this._loader.startProcess();
    let updateAcceptRejectRequest: AcceptRejectRequestPayload = {
      senderId: request.senderUserId,
      requestedFacilityId: request.requestedFacilityId,
      status: status,
    };    
    this._amplitudeAnalytics.logEvent({
      elementName: status, 
      action: 'Submit', 
      additionalProperty: {
        requestor: request.senderEmail,
        approver: request.approverEmail
      }
    });
    this.multiFacService.updateAcceptRejectRequest(updateAcceptRejectRequest).subscribe(
      (res) => {
        this.manageRequest = this.manageRequest.filter((_request) => {
          return _request != request;
        });
        let count = this.manageRequest.length;
        this.callOnClick.emit(count);
        if (status == 'APPROVED') {
          this._toast.creatToast(
            this.commonUtil.replaceValueAsHTMLOnTranslatedText('MANAGE.REQUEST.ACCEPT.TOAST', [
              this.getFullNameEmail(request.senderFirstName, request.senderLastName, request.senderEmail),
              request.requestedFacilityName,
            ])
          );
        } else {
          this._toast.creatToast(
            this.commonUtil.replaceValueAsHTMLOnTranslatedText('MANAGE.REQUEST.DENY.TOAST', [
              this.getFullNameEmail(request.senderFirstName, request.senderLastName, request.senderEmail),
              request.requestedFacilityName,
            ]),
            EToastType.ERROR
          );
        }
        this._loader.endProcess();
      },
      (err) => {
        this._loader.endProcess();
        if(err?.error?.title == 'invalid_operation') {
          this._toast.creatToast(this.commonUtil.translateText('ENTITY.NOT.EXISTS'), EToastType.ERROR);
        }
      }
    );
  }
}
